// extracted by mini-css-extract-plugin
export var boxItems = "_7v-1";
export var boxItemsLg = "_7v-2";
export var button = "_7v-7";
export var buttonHoverless = "_7v-9";
export var buttonLg = "_7v-8";
export var filterGroupBox = "_7v-0";
export var icon = "_7v-3";
export var iconSecondary = "_7v-6";
export var iconWrapper = "_7v-4";
export var iconWrapperLg = "_7v-5";
export var truncatedLabel = "_7v-a";